/** Sticker motion styles for REEL&SHORTS context overlays (preview + persist). */

export const DEFAULT_ARTIFACT_MOTION = 'thump';

export const ARTIFACT_MOTION_STYLES = [
  { id: 'none', label: 'None', hint: 'Sit still on the frame' },
  { id: 'thump', label: 'Thump', hint: 'Hop and land, like a sticker slap' },
  { id: 'jump', label: 'Jump', hint: 'Spring up and squash on landing' },
  { id: 'bounce', label: 'Bounce', hint: 'Soft repeats, less twist than thump' },
  { id: 'pop', label: 'Pop', hint: 'Punch in and settle' },
  { id: 'pulse', label: 'Pulse', hint: 'Steady breathe in and out' },
  { id: 'heartbeat', label: 'Heartbeat', hint: 'Double thump, then rest' },
  { id: 'shake', label: 'Shake', hint: 'Quick left-right jitter' },
  { id: 'wiggle', label: 'Wiggle', hint: 'Twist from the hips' },
  { id: 'swing', label: 'Swing', hint: 'Pendulum from the top' },
  { id: 'float', label: 'Float', hint: 'Slow rise and fall' },
  { id: 'slide', label: 'Slide', hint: 'Sway side to side' },
  { id: 'zoom', label: 'Zoom', hint: 'Grow and shrink' },
  { id: 'spin', label: 'Spin', hint: 'Full turn in place' },
  { id: 'flip', label: 'Flip', hint: 'Turn over like a card' },
];

const MOTION_IDS = new Set(ARTIFACT_MOTION_STYLES.map((row) => row.id));

const MOTION_ALIASES = {
  thumping: 'thump',
  jumping: 'jump',
  bouncing: 'bounce',
  popping: 'pop',
  pulsing: 'pulse',
  shaking: 'shake',
  wiggling: 'wiggle',
  swinging: 'swing',
  floating: 'float',
  sliding: 'slide',
  spinning: 'spin',
  flipping: 'flip',
  static: 'none',
  still: 'none',
  off: 'none',
};

export function sanitizeArtifactMotionStyle(value, fallback = DEFAULT_ARTIFACT_MOTION) {
  const raw = String(value || '').trim().toLowerCase().replace(/[-\s]+/g, '_');
  const key = MOTION_ALIASES[raw] || raw;
  if (MOTION_IDS.has(key)) return key;
  return MOTION_IDS.has(fallback) ? fallback : DEFAULT_ARTIFACT_MOTION;
}

export function artifactMotionStyleMeta(value) {
  const id = sanitizeArtifactMotionStyle(value);
  return ARTIFACT_MOTION_STYLES.find((row) => row.id === id) || ARTIFACT_MOTION_STYLES[1];
}

/** CSS class applied to the sticker box. `none` is a real class so reduced-motion can still win. */
export function artifactMotionClassName(value, { enabled = true } = {}) {
  if (!enabled) return '';
  return `artifact-sticker-motion artifact-sticker-motion-${sanitizeArtifactMotionStyle(value)}`;
}
